export const WIZARD_FADE_IN_TIME = 0.5;
export const CAST_ANIMATION_TIME = 3;
export const BOLT_ANIMATION_TIME = 1.1;
export const WIZARD_HOVER_TIME = 4;
export const FLAWLESS_REPAIR_TIME = 3;
export const FLAWLESS_REPAIR_DELAY = WIZARD_FADE_IN_TIME + CAST_ANIMATION_TIME * 0.55;
